<template>
  <div class="whole">
    <div class="title">
      <div class="back iconfont iconfanhui" @click="$router.go(-1)"></div>
      <p class="titleName">会员</p>
      <div class="navTool">
        <div class="icon_ iconfont iconwode" @click="addvipPopup()"></div>
        <div class="icon_ iconfont iconkucun" @click="$router.push('search')"></div>
      </div>
    </div>
    <div class="body">
      <table class="viptable" cellspacing="0">
        <tr class="vipTableName">
          <th>
            <p>序号</p>
          </th>
          <th>
            <p>编号</p>
          </th>
          <th>
            <p>姓名</p>
          </th>
          <th>
            <p>购买次数</p>
          </th>
          <th>
            <p>手机号码</p>
          </th>
          <th>
            <p>打折</p>
          </th>
          <th>
            <p>会员等级</p>
          </th>
        </tr>
        <tr class="vipTableContent">
          <td style="color:#AFAFAF">1</td>
          <td style="color:#242423">30459907</td>
          <td style="color:#AFAFAF">张小梦</td>
          <td style="color:#AFAFAF">4</td>
          <td style="color:#242423">13026867741</td>
          <td style="color:#AFAFAF">9折</td>
          <td>
            <button>vip会员</button>
          </td>
        </tr>
        <tr class="vipTableContent">
          <td style="color:#AFAFAF">1</td>
          <td style="color:#242423">30459907</td>
          <td style="color:#AFAFAF">张小梦</td>
          <td style="color:#AFAFAF">4</td>
          <td style="color:#242423">13026867741</td>
          <td style="color:#AFAFAF">9折</td>
          <td>
            <button>vip会员</button>
          </td>
        </tr>
      </table>
    </div>
    <div class="footer">
      <div class="vipMessage">
        <p>当前VIP会员人数:12123,普通会员人数:12111</p>
      </div>
      <div>
        <div class="pagination">
          <van-pagination
            class="pagination_btn"
            v-model="currentPage"
            :page-count="12"
            mode="simple"
          />
          <div class="pagination_goto">
            <input>
            <button>跳转</button>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="addvip" style="border-radius:4px;">
      <div class="addvip">
        <div class="popupHead">
          <p>添加会员</p>
        </div>
        <div class="popupContent">
          <div class="contentCell">
            <div class="inputBody">
              <input placeholder="请输入手机号码"/>
            </div>
            <div class="inputBtn">
              <button>获取验证码</button>
            </div>
            <p class="errorMsg"></p>
          </div>
          <div class="contentCell">
            <input placeholder="请输入验证码"/>
          </div>
        </div>
        <div class="popupFooter">
            <button class="popupNext" @click="nextPopup()">下一步</button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="addvipdata" style="border-radius:4px;">
      <div class="addvip">
        <div class="popupHead">
          <p>填写资料</p>
        </div>
        <div class="popupContent">
          <div class="contentCell">
            <input placeholder="真实姓名"/>
          </div>
          <div class="contentCell">
            <input placeholder="生日"/>
          </div>
          <div class="contentCell">
            <input placeholder="年龄"/>
          </div>
        </div>
        <div class="popupFooter">
            <button class="popupProp" @click="backPopup()">上一步</button>
            <button class="popupNext" @click="sub()">保存</button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="subPop">
      <div class="diag">
        <p>注册成功</p>
        <button  @click="closediag()">完成</button>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPage: 1,
      addvip: false,
      addvipdata:false,
      subPop:false,
      sms: "",
      username: "",
    };
  },
  created() {},
  methods: {
    addvipPopup() {
      this.addvip = !this.addvip;
    },
    nextPopup(){
      this.addvip = !this.addvip;
       this.addvipdata = ! this.addvipdata;
    },
    backPopup(){
      this.addvip = !this.addvip;
      this.addvipdata = ! this.addvipdata;
    },
    sub(){
      this.addvipdata = ! this.addvipdata;
      this.subPop = ! this.subPop;
    },
    closediag(){
       this.subPop = ! this.subPop;
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.whole {
  min-height: 100vh;
  background: #efefef;
  overflow: hidden;
  .title {
    width: 100%;
    position: fixed;
    height: 44px;
    background: #fff;
    text-align: center;
    z-index: 2;
    .back {
      position: absolute;
      top: 0px;
      left: 10px;
      width: 44px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      font-size: 20px;
    }
    .titleName {
      font-size: 14px;
      margin: auto;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      z-index: -1;
    }
    .navTool {
      position: absolute;
      display: flex;
      top: 0px;
      right: 10px;
      height: 44px;
      text-align: center;
      .icon_ {
        width: 44px;
        height: 44px;
        line-height: 44px;
        font-size: 24px;
        margin-right: 10px;
      }
    }
  }
  .body {
    margin-top: 44px;
    .viptable {
      width: 100%;
      table-layout: fixed;
      text-align: center;
      .vipTableName {
        background: #fff;
        padding: 0px;
        th {
          padding: 0px;
          border-top: 4px solid #e3e1e1;
          border-bottom: 4px solid #e3e1e1;
          p {
            font-size: 12px;
            font-weight: 300;
            border-right: 1px solid #999999;
            margin: 12px 0px;
          }
        }
        th:last-child > p {
          border-right: 0px;
        }
      }
      .vipTableContent {
        td {
          font-size: 11px;
          padding: 15px 0px;
          font-weight: 400;
          button {
            width: 94px;
            height: 23px;
            border: 1px solid rgba(16, 16, 16, 1);
            border-radius: 4px;
            background: transparent;
          }
        }
      }
    }
    .vipTableContent:nth-child(even) {
      background: #fff;
    }
    .vipTableContent:nth-child(odd) {
      background: #f2f2f2;
    }
  }
  .footer {
    position: fixed;
    bottom: 0px;
    height: 50px;
    width: 100%;
    background: #fff;
    .vipMessage {
      position: absolute;
      top: 0px;
      left: 20px;
      p {
        font-size: 12px;
        height: 50px;
        line-height: 50px;
        margin: 0px;
        color: #898989;
      }
    }
    .pagination {
      height: 40px;
      width: 330px;
      margin: 0px auto;
      display: flex;
      position: relative;
      margin-top: 5px;
      z-index: 2;
      background: #fff;
      .pagination_btn {
        width: 200px;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
      }
      .pagination_goto {
        margin-left: 10px;
        width: 130px;
        display: flex;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        input {
          width: 70px;
          font-size: 12px;
          color: #3a3a3a;
          border: 1px solid #3a3a3a;
          padding: 3px;
          border-radius: 4px;
        }
        button {
          min-width: 40px;
          margin-left: 10px;
          font-size: 12px;
          background: transparent;
          color: #3a3a3a;
          border: 1px solid #3a3a3a;
          border-radius: 4px;
        }
      }
    }
  }
  .addvip {
    width: 464px;
  }
  .popupHead {
    height: 44px;
    background: #e6e6e6;
    width: 100%;
    p {
      margin: 0px;
      font-size: 16px;
      text-align: center;
      line-height: 44px;
    }
  }

  .popupContent {
    padding: 51px 20px 10px 20px;
  }

  .popupFooter {
    padding: 20px 0px;
    text-align: center;
    button{
        width:141px;
        height:43px;
        border-radius:4px;
    }
      .popupProp{
        background:#fff;
        border: 1px solid rgb(67,67,73);
        color: #363636;
      }
      .popupNext{
        margin-left: 10px;
        background:rgb(54,54,54);
        border: 1px solid rgb(54,54,54);
        color: #fff;
      }
  }

  .contentCell {
    display: flex;
    width: 308px;
    height: 39px;
    margin: 20px auto;
    flex-grow: 0;
    .inputBody {
      display: flex;
      width: auto;
      flex-grow: 1;
      background: #EAEAEA;
      padding: 3px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    input {
      width: 100%;
      border: 0px;
      background: #EAEAEA;
      border-radius: 4px;
      padding: 0px 4px;
    }
    .inputBtn {
      padding:0px 3px;
      background: #EAEAEA;
      display: block;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      button {
        position: relative;
        transform: translateY(-50%);
        top: 50%;
        width:83px;
        height:32px;
        background:rgb(54,54,54);
        border-radius:4px;
        border: 0px;
        color: #fff;
      }
    }
  }
  .diag{
    background: #fff;
    border-radius:4px;
    width:200px;
    overflow: hidden;
    p{
      margin: 0px;
      padding: 25px;
      border-bottom: 1px solid #F2F2F2;
      text-align: center;
      font-size: 14px;
    }
    button{
      border: 0px;
      width: 100%;
      height: 50px;
      line-height: 48px;
      background: transparent;
      color: #1989fa;
      font-size: 14px;
    }
  }
}
</style>